<button *ngIf="middle"
    class="btn btn-round btn-primary btn-warning"
    (click)="checkout($event)">
    Buy Now
</button>
<button *ngIf="!middle"
    class="btn btn-round btn-neutral btn-success"
    (click)="checkout($event)">
    Buy Now
</button>